import AdultSymptomExercisePage from '@/components/AdultSymptomExercisePage';
import { useLocaleStore } from '@/lib/stores/localeStore';
import { createFileRoute } from '@tanstack/react-router';
import ExerciseImage from '@/assets/exercise-background-photos/anixiety.png';
import anxietyMp4 from '@/assets/videos/adults-symptoms/anxiety/anxiety.mp4';
import anxietyWebm from '@/assets/videos/adults-symptoms/anxiety/anxiety.webm';
import anxietyAr from '/subs/anxiety.ar.vtt';
import anxietyEn from '/subs/anxiety.en.vtt';
import { isAdultExerciseGroup } from '@/lib/data/contentCatalog';

export const Route = createFileRoute('/(content)/adults/exercises/anxiety/')({
  component: RouteComponent,
  validateSearch: (search: Record<string, unknown>) => ({
    group: isAdultExerciseGroup(search.group) ? search.group : undefined,
    mode:
      search.mode === 'videos' || search.mode === 'exercises'
        ? (search.mode as 'videos' | 'exercises')
        : undefined,
  }),
  head: () => ({
    meta: [{ title: 'Anxiety - HAMD' }],
  }),
  beforeLoad: () => ({
    title: 'exercises.categories.anxiety',
    navbar: {
      transparent: true,
      showTitle: false,
    },
  }),
});

function RouteComponent() {
  const { group, mode } = Route.useSearch();
  const navigate = Route.useNavigate();
  const locale = useLocaleStore((state) => state.locale);
  const captionsDir: 'ltr' | 'rtl' = locale === 'ar' ? 'rtl' : 'ltr';

  const videos = [
    {
      sources: [{ src: anxietyWebm, type: 'video/webm' }, { src: anxietyMp4, type: 'video/mp4' }],
      videoClassName: 'w-full h-full object-contain object-top',
      containerBg: 'var(--secondary)',
      subtitleTracks: [
        { src: anxietyAr, srcLang: 'ar', label: 'Arabic', default: true },
        { src: anxietyEn, srcLang: 'en', label: 'English' },
      ],
      activeSubtitleLanguage: locale === 'ar' ? 'ar' : 'en',
      captionsDir,
      defaultCaptionsVisible: true,
      showCaptionsToggle: true,
    },
  ];

  return (
    <AdultSymptomExercisePage
      symptom="anxiety"
      titleKey="exercises.categories.anxiety"
      heroImage={ExerciseImage}
      videos={videos}
      mode={mode}
      onModeChange={(nextMode) =>
        navigate({
          to: Route.to,
          search: {
            mode: nextMode ?? undefined,
            group: nextMode === 'exercises' ? group : undefined,
          },
        })
      }
      selectedGroup={group}
      onSelectGroup={(nextGroup) =>
        navigate({
          to: Route.to,
          search: { mode: 'exercises', group: nextGroup },
        })
      }
    />
  );
}
